<template>
  <div
    class="hkl-status-badge"
    :class="color"
    v-on="$listeners"
  >
    {{ value }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => (''),
    },
    color: {
      type: String,
      default: 'grey',
      validator: (val) => {
        const validColors = [
          'grey',
          'yellow',
          'light-green',
          'dark-orange',
          'red',
          'light-blue',
        ]
        return validColors.includes(val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.hkl-status-badge {
  height: 37px;
  padding: 0 9px;
  font-weight: bold;
  line-height: 37px;
  &.grey {
    color: #6e7a92;
    border: solid 1px #6e7a92;
  }
  &.yellow {
    color: #e69500;
    border: solid 1px #e69500;
  }
  &.light-green {
    color: #009588;
    border: solid 1px #009588;
  }
  &.dark-orange {
    color: #ae7001;
    border: solid 1px #ae7001;
  }
  &.red {
    color: #f44336;
    border: solid 1px #f44336;
  }
  &.light-blue {
    color:  #7596c9;
    border: solid 1px #7596c9;
  }
}

</style>
